export const formatUnit: (
    options: Omit<Intl.NumberFormatOptions, "style"> | undefined,
) => (value: number | bigint) => string = (opts) => (value) => {
    return new Intl.NumberFormat("nb", {
        style: "unit",
        unit: "kilometres",
        ...opts,
    }).format(value);
};
